import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ContentWrapper = styled.div`
  max-width: 466px;
  margin-top: ${Spacing.S32};
`
